var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e;
import { Component } from 'angular-ts-decorators';
import JSONEditor from 'jsoneditor';
const MODE_TREE = 'tree';
const MODE_CODE = 'code';
const LOCALSTORAGE_KEY_VIEW = 'admin-settings-view';
const DEFAULT_PAGE_SIZE = 10;
let RevisionController = class RevisionController {
    $http;
    $scope;
    $timeout;
    $translate;
    settingsService;
    organizationService;
    jsonEditor;
    editorOptions = { mode: MODE_CODE, onChange: this.onChangeHandler.bind(this) };
    editorChangeListener;
    unsubscribeFromEditorChanges;
    data;
    isFullscreen = false;
    isLoading = true;
    showSavedFailedMessage = false;
    showSavedMessage = false;
    userFeedback = { show: true, message: '', type: null };
    // Revision Editor state
    activeRevision = null; // the currently active revision
    isJsonValid = true; // Variable to track whether the editor data is in valid state or not
    mode = (window.localStorage.getItem(LOCALSTORAGE_KEY_VIEW) || MODE_CODE);
    organization_search_term = '';
    organizations = [];
    organizationId = null; // assigned in the super-admin.html template
    organizationsLoading = false;
    revisionCount = 0;
    revisions = [];
    selectedOrganization = null;
    selectedRevision = null; // the currently selected revision from dropdown
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$http', '$scope', '$timeout', '$translate', 'OrganizationService', 'SettingsService'];
    constructor($http, $scope, $timeout, $translate, organizationService, settingsService) {
        this.$http = $http;
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$translate = $translate;
        this.organizationService = organizationService;
        this.settingsService = settingsService;
        this.organizationService = organizationService;
        this.editorChangeListener = (settings) => {
            this.data = settings;
            if (this.jsonEditor) {
                this.jsonEditor.set(this.data);
            }
        };
        this.setupEditor().catch((e) => {
            console.error('Failed to setup editor', e);
        });
    }
    ngOnInit() {
        this.settingsService.addChangeListener('JSON_EDITOR', '', this.editorChangeListener);
        this.unsubscribeFromEditorChanges = this.$scope.$watch(() => this.organization_search_term, this.loadOrganizations.bind(this));
    }
    ngOnDestroy() {
        if (this.unsubscribeFromEditorChanges) {
            this.settingsService.removeChangeListener('JSON_EDITOR');
            this.unsubscribeFromEditorChanges();
            this.unsubscribeFromEditorChanges = undefined;
        }
    }
    async setupEditor() {
        try {
            this.editorOptions.mode = (window.localStorage.getItem(LOCALSTORAGE_KEY_VIEW) || MODE_CODE);
        }
        catch (e) {
            /* ignored, just keeps default MODE_CODE */
        }
        this.jsonEditor = new JSONEditor(document.getElementById('jsoneditor'), this.editorOptions);
        this.editorLoaded(this.jsonEditor);
        // Initialize - this will automatically load all revisions for the currently active organization
        await this.loadRevisions(null, DEFAULT_PAGE_SIZE, 1);
        await this.loadOrganization(this.selectedRevision.organization_id);
    }
    onChangeHandler() {
        try {
            this.data = JSON.parse(this.jsonEditor.getText());
            this.$timeout(() => (this.isJsonValid = true), 0, true);
        }
        catch (e) {
            // Invalid JSON found
            this.$timeout(() => (this.isJsonValid = false), 0, true);
        }
    }
    backToSettings() {
        window.location.assign('/settings/system-integration');
    }
    toggleFullscreen() {
        this.isFullscreen = !this.isFullscreen;
        if (this.jsonEditor) {
            this.jsonEditor.refresh();
        }
    }
    editorLoaded(jsonEditor) {
        // Not sure why, but the latest types says 'jsonEditor.editorDom' does not exist,
        // but the JSONEditor instance itself still has that
        $(jsonEditor.editorDom).bind('keydown', (event) => {
            if (event.ctrlKey || event.metaKey) {
                switch (String.fromCharCode(event.which).toLowerCase()) {
                    case 's':
                        event.preventDefault();
                        this.saveRevision(this.selectedRevision);
                        break;
                    case 'r':
                        event.preventDefault();
                        this.loadRevisions(null, DEFAULT_PAGE_SIZE, 1);
                        break;
                }
            }
        });
    }
    toggleView() {
        if (this.mode === MODE_CODE) {
            this.mode = MODE_TREE;
        }
        else {
            this.mode = MODE_CODE;
        }
        this.jsonEditor.setMode(this.mode);
        try {
            window.localStorage.setItem(LOCALSTORAGE_KEY_VIEW, this.mode);
        }
        catch (e) { }
    }
    changeEditorData(data) {
        this.data = data;
        this.jsonEditor.set(data);
    }
    showFeedbackMessage(type, message) {
        this.userFeedback.type = type;
        this.userFeedback.message = this.$translate.instant(message);
        this.userFeedback.show = true;
        $('#feedback').text(this.userFeedback.message);
        this.$timeout(() => {
            this.userFeedback.show = false;
        }, 2500);
    }
    /**
     * Revisions related functions below
     */
    loadRevisions(organizationId, limit, page) {
        this.isLoading = true;
        return this.settingsService
            .getRevisions(organizationId, limit, page)
            .then(async (response) => {
            const { numRevisions, revisions } = response.data;
            this.revisions = revisions;
            this.revisionCount = numRevisions;
            let activeRevision = this.revisions.find((rev) => rev.active === true);
            // grab active revision if not included already
            if (!activeRevision) {
                activeRevision = (await this.settingsService.getActiveRevisions(organizationId)).data;
                this.revisions.unshift(activeRevision);
            }
            this.setActiveRevision(activeRevision);
            this.selectRevision(activeRevision);
        })
            .catch((response) => {
            console.error(response);
        })
            .finally(() => {
            this.isLoading = false;
        });
    }
    loadAllRevisions() {
        return this.loadRevisions(this.selectedOrganization.organization_id);
    }
    setActiveRevision(revision) {
        this.activeRevision = revision;
    }
    formatRevisionExtended(revision) {
        const revisionName = revision.settings && revision.settings.name;
        let label = '';
        label += `${revision._local ? '*' : ''} `;
        label += `Version ${revision.version}`;
        label += `${revision.active ? ` (${this.$translate.instant('JSON_EDITOR_REVISION_ACTIVE')})` : ''}`;
        label += `${revisionName ? ': ' + revisionName : ''} `;
        label += `${revision.editable ? '🖊' : ''} `;
        label += `${revision.approved ? '✓' : ''} `;
        label = label.replace(/\s+/g, ' ');
        return label;
    }
    getNameAndDateOfRevision(revision) {
        return `${revision.last_update_by} (${new Date(revision.updated_at).toLocaleString()})`;
    }
    setRevisionAsActive(revision) {
        return this.settingsService
            .setRevisionAsActive(revision)
            .then(() => {
            this.revisions.forEach((r) => {
                if (r.id === revision.id) {
                    r.active = true;
                    this.setActiveRevision(r);
                }
                else {
                    r.active = false;
                }
            });
            revision.active = true;
            this.showFeedbackMessage('success', 'JSON_EDITOR_REVISION_ACTIVATE_SUCCESS');
            this.flushFieldDefinitionsCache();
            return revision;
        })
            .catch((response) => {
            console.error('Failed to set revision as active', response);
            this.showFeedbackMessage('warning', 'JSON_EDITOR_REVISION_ACTIVATE_FAILURE');
        });
    }
    selectRevision(revision) {
        if (!revision) {
            return;
        }
        this.selectedRevision = revision;
        this.changeEditorData(revision.settings);
        if (!window['__snapADDY']?.hasDashboardAccess && this.jsonEditor) {
            revision.editable ? this.jsonEditor.setMode('code') : this.jsonEditor.setMode('view');
        }
    }
    onRevisionSelect() {
        this.selectRevision(this.selectedRevision);
    }
    copyRevision(revision) {
        if (revision.approved &&
            !confirm('You are duplicating an approved revision?\nYour copy might need to be approved again to work properly.')) {
            return Promise.resolve();
        }
        const copy = JSON.parse(JSON.stringify(revision));
        copy.id = '';
        copy.version = this.findNextInteger(this.revisions, 'version');
        copy.active = false;
        copy.editable = true;
        copy.approved = false;
        copy.approved_by = null;
        copy.approved_at = null;
        copy.created_at = new Date();
        copy.updated_at = new Date();
        copy._local = true;
        copy.last_update_by = 'Customer';
        this.addLocalRevision(copy, false);
        return this.saveRevision(copy)
            .then((savedRevision) => {
            if (savedRevision) {
                this.selectRevision(savedRevision);
                if (savedRevision.active) {
                    this.setActiveRevision(savedRevision);
                }
                this.revisionCount++;
            }
        })
            .catch((error) => {
            console.error('Error during saving a duplicated revision', error);
        });
    }
    removeLocalRevision(revision) {
        this.revisions = this.revisions.filter((r) => {
            return r.id !== revision.id;
        });
        if (this.selectedRevision?.id === revision.id) {
            this.selectRevision(this.activeRevision);
        }
    }
    addLocalRevision(revision, select) {
        this.revisions.push(revision);
        if (select) {
            this.selectRevision(revision);
        }
    }
    swapLocalRevisions(old_revision, new_revision) {
        this.revisions = this.revisions.map((r) => (r.id === old_revision.id ? new_revision : r));
    }
    handleLocalRevisionUpdate(oldRevision, newRevision) {
        this.swapLocalRevisions(oldRevision, newRevision);
        if (newRevision.active) {
            this.setActiveRevision(newRevision);
        }
        this.showSavedMessage = true;
        this.$timeout(() => {
            this.showSavedMessage = false;
        }, 1500);
        return newRevision;
    }
    saveRevision(revision) {
        // Check if current editor state is valid JSON, if not we cannot save
        if (this.isJsonValid === false) {
            this.showFeedbackMessage('warning', 'JSON_EDITOR_INVALID_JSON');
            return;
        }
        revision.settings = this.data;
        if (revision.approved &&
            !confirm('Do you really want to update an approved revision?\nIt might need to be approved again to work properly.')) {
            return;
        }
        if (revision._local) {
            // create new one
            return this.settingsService
                .createRevision(revision)
                .then((response) => {
                const rev = response.data;
                this.handleLocalRevisionUpdate(revision, rev);
                this.showFeedbackMessage('success', 'JSON_EDITOR_REVISION_SAVE_SUCCESS');
                this.flushFieldDefinitionsCache();
                return rev;
            })
                .catch((response) => {
                try {
                    switch (response.data.code) {
                        // deprecated, approved revisions can be edited now, but lose the approved status
                        case 'MISSING_PERMISSION_TO_ALTER_APPROVED_REVISION':
                            this.showFeedbackMessage('warning', 'JSON_EDITOR_REGULAR_ADMIN_CANT_ALTER_APPROVED_REVISION');
                            break;
                        case 'MISSING_REVISION_AUTHOR_STATUS':
                            this.showFeedbackMessage('warning', 'JSON_EDITOR_MISSING_REVISION_AUTHOR_STATUS');
                            break;
                        default:
                            this.showFeedbackMessage('warning', 'JSON_EDITOR_REVISION_SAVE_FAILURE');
                    }
                    this.selectRevision(revision);
                }
                catch (e) {
                    console.error('Error during saving a new revision', e);
                }
            });
        }
        // update existing one
        return this.settingsService
            .updateRevision({ ...revision, approved: false })
            .then((response) => {
            const rev = response.data;
            this.handleLocalRevisionUpdate(revision, rev);
            this.showFeedbackMessage('success', 'JSON_EDITOR_REVISION_SAVE_SUCCESS');
            this.flushFieldDefinitionsCache();
            return rev;
        })
            .catch((err) => {
            try {
                switch (err.data.code) {
                    case 'MISSING_PERMISSION_TO_ALTER_APPROVED_REVISION':
                        this.showFeedbackMessage('warning', 'JSON_EDITOR_REGULAR_ADMIN_CANT_ALTER_APPROVED_REVISION');
                        break;
                    case 'MISSING_REVISION_AUTHOR_STATUS':
                        this.showFeedbackMessage('warning', 'JSON_EDITOR_MISSING_REVISION_AUTHOR_STATUS');
                        break;
                    default:
                        this.showFeedbackMessage('warning', 'JSON_EDITOR_REVISION_SAVE_FAILURE');
                }
                this.selectRevision(revision);
            }
            catch (e) {
                console.error('Error during saving an existing revision', e);
            }
        });
    }
    // Dismisses all non-saved changes, resetting to entry-point organization
    // `organizationId`
    dismissChanges() {
        this.loadRevisions(this.organizationId, DEFAULT_PAGE_SIZE, 1).then(() => {
            this.selectedOrganization = this.organizations.filter((o) => o.organization_id === this.organizationId)[0];
        });
    }
    deleteRevision(revision) {
        if (!window.confirm(this.$translate.instant('JSON_EDITOR_REVISION_DELETE_CONFIRM'))) {
            return;
        }
        if (revision.active === true) {
            this.showFeedbackMessage('warning', 'JSON_EDITOR_ACTIVE_REVISION_CANT_BE_DELETED');
            return;
        }
        if (revision._local === true) {
            // only need to delete locally as it is not persisted yet
            this.removeLocalRevision(revision);
            this.showFeedbackMessage('success', 'JSON_EDITOR_REVISION_DELETE_SUCCESS');
            return;
        }
        this.settingsService
            .deleteRevision(revision.id)
            .then(() => {
            this.removeLocalRevision(revision);
            this.selectRevision(this.activeRevision);
            this.revisionCount--;
            this.showFeedbackMessage('success', 'JSON_EDITOR_REVISION_DELETE_SUCCESS');
        })
            .catch((response) => {
            try {
                switch (response.data.code) {
                    case 'MISSING_PERMISSION_TO_ALTER_APPROVED_REVISION':
                        this.showFeedbackMessage('warning', 'JSON_EDITOR_REGULAR_ADMIN_CANT_ALTER_APPROVED_REVISION');
                        break;
                    case 'MISSING_REVISION_AUTHOR_STATUS':
                        this.showFeedbackMessage('warning', 'JSON_EDITOR_MISSING_REVISION_AUTHOR_STATUS');
                        break;
                    default:
                        this.showFeedbackMessage('warning', 'JSON_EDITOR_REVISION_DELETE_FAILURE');
                }
                this.selectRevision(revision);
            }
            catch (e) {
                console.error('Error during deleting a revision', e);
            }
        });
    }
    approveRevision(revision) {
        if (!window.confirm('Do you want to approve the selected revision?')) {
            return;
        }
        return this.settingsService
            .approveRevision(revision)
            .then((response) => {
            const updated_revision = response.data;
            this.swapLocalRevisions(revision, updated_revision);
            return updated_revision;
        })
            .catch((err) => {
            this.showFeedbackMessage('warning', err.data.code);
        });
    }
    isDeleteRevisionButtonDisabled() {
        // Revisions may be deleted if the currently selected one is NOT the currently active one
        return this.activeRevision !== null &&
            this.selectedRevision !== null &&
            this.selectedRevision.id === this.activeRevision.id
            ? true
            : false;
    }
    onOrganizationSelect() {
        if (!this.selectedOrganization) {
            return;
        }
        this.loadRevisions(this.selectedOrganization.organization_id, DEFAULT_PAGE_SIZE, 1);
    }
    /**
     * Flushing field definitions of all members of the current organization that might have got stored by any client
     * like suggestion-lambdas or the grabber. Just in case a new mapping might change the definitions for the client,
     * this shouldn't be necessary in most cases and we don't need to await the cache purge because it's not used at
     * this place anyway.
     */
    flushFieldDefinitionsCache() {
        this.$http
            .delete('watchdog/v1/field-definitions-cache/flush-organization')
            .then((_success) => console.log('Successfully flushed field definitions cache'))
            .catch((error) => console.error('Error while flushing field definitions cache', error));
    }
    findNextInteger(array, attr) {
        const currentMaxValue = array
            .map((rev) => {
            return rev[attr];
        })
            .sort((left, right) => {
            return left > right ? -1 : 1;
        })[0];
        return currentMaxValue + 1;
    }
    async loadOrganizations() {
        if (this.organization_search_term.length > 2) {
            this.organizationsLoading = true;
            this.organizations = (await this.organizationService.getOrganizations(0, // Page
            50, // Page-Size (Limit)
            this.organization_search_term, // Filter
            false, // encodeIds
            false, // onlyOrga
            false)).orgas;
            this.organizations.sort((a, b) => (b.current_user_count || 0) - (a.current_user_count || 0));
            this.selectedOrganization = this.organizations[0];
            this.organizationsLoading = false;
            if (this.selectedOrganization) {
                this.loadRevisions(this.selectedOrganization.organization_id, DEFAULT_PAGE_SIZE, 1);
            }
            else {
                // Manually apply scope because in this case change detection does not trigger
                this.$scope.$apply();
            }
        }
    }
    async loadOrganization(organizationId) {
        const orga = await this.organizationService.getOrganizationById(organizationId);
        this.organizations = [orga];
        this.selectedOrganization = this.organizations[0];
        // Manually apply scope
        this.$scope.$apply();
    }
};
RevisionController = __decorate([
    Component({
        selector: 'app-revision-controller',
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof ng !== "undefined" && ng.IHttpService) === "function" ? _a : Object, typeof (_b = typeof ng !== "undefined" && ng.IScope) === "function" ? _b : Object, typeof (_c = typeof ng !== "undefined" && ng.ITimeoutService) === "function" ? _c : Object, typeof (_e = typeof angular !== "undefined" && (_d = angular.translate) !== void 0 && _d.ITranslateService) === "function" ? _e : Object, Object, Object])
], RevisionController);
export { RevisionController };
